import { requestRefreshToken } from './auth-network';
import { decodeToken, getTokenExpireMinute, isTokenNotExpired } from './AuthUtil';
import {
  getCredentialsSession,
  persistCredentialsSession,
  clearCredentialsSession,
} from './auth-storage';

const DEFAULT_PERIOD = 10000;
const REFRESH_ACCESS_TOKEN_BEFORE = 5; // Minutes

const runAcessTokenChecker = (
  onRefreshSuccess = () => { },
  onRefreshFailed = () => { },
  period = DEFAULT_PERIOD,
) => {
  setTimeout(function checkAccessToken() {
    try {
      const data = getCredentialsSession();
      const decodedAccessToken = decodeToken(data.accessToken);
      const timeToExpire = getTokenExpireMinute(decodedAccessToken.exp);

      if (timeToExpire > REFRESH_ACCESS_TOKEN_BEFORE) {
        setTimeout(checkAccessToken, period);
      } else {
        const decodedRefreshToken = decodeToken(data.refreshToken);

        if (isTokenNotExpired(decodedRefreshToken.exp)) {
          requestRefreshToken(data.refreshToken)
            .then((response) => {
              const newToken = response.data.refreshToken.token;
              persistCredentialsSession(newToken, data.refreshToken);

              onRefreshSuccess();
              setTimeout(checkAccessToken, period);
            }).catch(() => {
              clearCredentialsSession();
              onRefreshFailed();
            });
        } else {
          throw new Error('Refresh token failed');
        }
      }
    } catch (error) {
      clearCredentialsSession();
      onRefreshFailed();
    }
  }, 0);
};

export default runAcessTokenChecker;
